module.exports = __webpack_public_path__ + "img/aston-villa.58c0f873.png";